import React, { useState } from 'react'
import { setSerialNumber, setTag } from '../../../Api Methods/Api';
import Input from '../../CustomDropDown/Input/Input';
import Button1 from '../../UI/Button/Button1';
import classes2 from "../../forms/InviteUserForm.module.css"
import classes from "./SetTag.module.css"
import { GetSingleDeviceData } from '../../../store/service-actions';
import { serviceActions } from "../../../store/service-Slice";
import { Button } from 'primereact/button';

const SetSerial = ({ placeholder, DeviceUUID, HandleCloseModal, dispatch, setUpdateSerial, update, setUpdate, siteDevices, setSiteDevices, siteData, setSiteData, isManualSet, headerData, setHeaderData, successModal, errorModal }) => {
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');

    const [serial, setSerial] = useState(placeholder);

    const handleInputChange = (event) => {
        setSerial(event.target.value);
    };

    const handleCancel = () => {
        setSerial('');
        HandleCloseModal();
    };

    const handleSaveTag = async () => {
        const apiData = {
            token,
            client,
        }

        const body = {
            "serialNumber": serial,
            "uuid": DeviceUUID
        }

        const response = await setSerialNumber(apiData, body, dispatch);
        if (response) {
            HandleCloseModal();
            setUpdate(update+1);
            successModal("Serial number successfully updated");

            if (siteData){
                siteData[1].subGroup = serial
                dispatch(serviceActions.updatingSingleDeviceData(siteData[1]));
                
            }
            
            //dispatch(getSingleDeviceData(DeviceUUID, apiData))
            if (setSiteDevices){
                setSiteDevices((prevSiteDevices) =>
                    prevSiteDevices.map((device) =>
                        device.uuid === DeviceUUID ? { ...device, subGroup: serial } : device
                    )
                );
            }
        } else {
            errorModal("Failed to update serial number, please try again")
        }
    }

    return (
        <form onSubmit={handleSaveTag} className={classes2["container"]} method="dialog" >
            <ul className={classes2["inputs-list"]}>
                <li className={classes2["input-container"]}>
                    <Input
                        type="text"
                        value={serial}
                        onChange={handleInputChange}
                        placeholder={placeholder}
                    />
                </li>
                <div className={classes.form}>
                    <Button icon="pi pi-times" onClick={handleCancel} label="Cancel" severity='secondary'/>
                    <Button icon="pi pi-save" type="submit" label="Save" severity='success'/>
                </div>
            </ul>
        </form>
    )
}

export default SetSerial;